var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hide)?_c('div',{staticClass:"section-wrapper text-left mb-4"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }